/*
 * Copyright (c) Kalaora 2022.
 * Author: fharold
 *
 * hilo-oauth-manager
 * StandardPolicy.tsx
 */

import Policy from "../tools/provider/Policy";

export default class StandardPolicy implements Policy {
    /**
     * canSeeUsers
     * @returns {boolean}
     */
    public canSeeUsers(): boolean {
        return false;
    }
}